import { CERTIFICATION_COST_CODE_FRAGMENT } from 'apollo/fragments/certification-cost-code-fragments';
import gql from 'graphql-tag';

const CostCodesFragments = {
  details: gql`
    fragment CostCodeDetails on CostCode {
      id
      costCode
      costCodeGroup {
        id
        groupName
      }
      costCodeGroupId
      title
      unitTitle
      workersCompId
      createdOn
      updatedOn
      archivedOn
      updatedByMember {
        id
        firstName
        lastName
      }
      customField1
      customField2
      customField3
      customField4
      customField5
      certificationLinks {
        ...CertificationCostCode
      }
    }
    ${CERTIFICATION_COST_CODE_FRAGMENT}
  `,
};

export const costCodesQuery = gql`
  query costCodes($filter: CostCodeFilter!, $first: Int, $after: String, $sort: [CostCodeSort!]) {
    costCodes(filter: $filter, first: $first, after: $after, sort: $sort) {
      cursor
      ...CostCodeDetails
    }
  }
  ${CostCodesFragments.details}
`;

export const createCostCodeMutation = gql`
  mutation createCostCode2($costCode: CostCodeCreateInput!) {
    createCostCode(costCode: $costCode) {
      ...CostCodeDetails
    }
  }
  ${CostCodesFragments.details}
`;

export const updateCostCodeMutation = gql`
  mutation updateCostCode($costCode: CostCodeUpdateInput!) {
    updateCostCode(costCode: $costCode) {
      ...CostCodeDetails
    }
  }
  ${CostCodesFragments.details}
`;

export const importCostCodeMutation = gql`
  mutation createCostCode3($costCode: CostCodeCreateInput!) {
    createCostCode(costCode: $costCode) {
      costCode
      title
      unitTitle
    }
  }
`;
